import React from 'react';

interface CustomNode {
  name: string;
  attribs?: {
    href?: string;
    download?: string;
  };
}

export function NotificationsAnchor(addTab: any, cls: Record<string, string>) {
  return function CustomAnchor(node: CustomNode, children: React.ReactNode) {
    const link = node?.attribs?.href;
    const download = node?.attribs?.download;

    if (download === 'true') {
      return (
        <a
          download={true}
          key={`${node.name}-${link}`}
          className={cls.anchor}
          href={process.env.PUBLIC_URL + link}
        >
          {children}
        </a>
      );
    }

    return (
      <span
        key={`${node.name}-${link}`}
        className={cls.anchor}
        onClick={() => {
          link && addTab(link);
        }}
      >
        {children}
      </span>
    );
  };
}
